<template>
  <b-modal
    id="user-list-modal"
    :visible="_value"
    hide-header
    hide-footer
    body-class="user-list-modal"
    @hidden="_value = false">
    <div
      class="user-list-modal-cross">
      <b-icon-x-circle-fill
        style="cursor: pointer;"
        @click="_value = false" />
    </div>
    <div class="text--grey05 d-flex align-items-center mt-3">
      <span
        v-if="icon"
        class="material-icons mr-1"
        style="font-size: 1rem;">{{ icon }}</span>
      <span>{{ title }}</span>
    </div>

    <div class="mt-3">
      <div v-if="users.length > 0">
        <app-list-item
          v-for="user in users"
          :key="user.id"
          :avatar="user.avatar"
          :name="user.name"
          :group="user.department.name"
          :position="user.position" />
      </div>
      <p
        v-else
        style="font-size: 14px;">
        {{ noUserMessage }}
      </p>
    </div>
  </b-modal>
</template>

<script>
import AppListItem from '@/components/parts/AppListItem'
export default {
  components: {
    AppListItem
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      required: true
    },
    noUserMessage: {
      type: String,
      default: ''
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-list-modal {
  position: relative;

  &-cross {
    position: absolute;
    top: 5px;
    right: 5px;
    display: flex;
    justify-content: flex-end;
    font-size: 20px;
    color: $grey04;
  }
}
</style>